import gql from 'graphql-tag'

export const newProductUpdate = gql`
  mutation NewProductUpdate($input: NewProductUpdateInput!) {
    newProductUpdate(input: $input) {
      success
    }
  }
`
